/** @format */

/* eslint @typescript-eslint/prefer-nullish-coalescing: "warn" -- Legacy code: do not use as an example. */
import { isBrowser } from '@toucan/client/global/nextjs';

/**
 * Polyfills Element.prototype.closest
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
function polyfillElementClosest() {
    if (!Element.prototype.matches) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        Element.prototype.matches =
            // @ts-ignore
            Element.prototype.msMatchesSelector ||
            // eslint-disable-next-line @typescript-eslint/unbound-method -- Legacy code: do not use as an example.
            Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        // eslint-disable-next-line id-length -- Legacy code: do not use as an example.
        Element.prototype.closest = function (s: string) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias -- Legacy code: do not use as an example.
            let el = this;

            do {
                if (el.matches(s)) {
                    return el;
                }
                el = el.parentElement || (el.parentNode as Element);
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }
}

if (isBrowser()) {
    polyfillElementClosest();
}
